import { NavigationState } from "../../types";

export const resetClientEventHistoryFilter = (state: NavigationState) => {
  state.clientEventsPathFilters = [];
};
